import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators as val } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ProviderListService } from 'src/app/dashboard/admin/report/services/gate-services/provider-list.service';
import { CustomValidators } from '../../../../../../../shared/custom-validators';
import { Validators } from '../../../../../../../shared/validators';

import paymentOptionsConstant from 'src/app/shared/paymentOptionsConstant';
import { FormValidatorService } from '../../../../../../../shared/services/form-validator.service';
import { PaymentMethodsService } from '../../services/payment-methods.service';
import { TranslateService } from '@ngx-translate/core';
const PaymentOptions=paymentOptionsConstant.constantgatePaymentOptions
@Component({
  selector: 'app-manage-merchants',
  templateUrl: './manage-merchants.component.html',
  styleUrls: ['./manage-merchants.component.scss']
})
export class ManageMerchantsComponent  implements OnInit {
  cashProviders : object [] = [];
  migsProviders : object [] = [];
  mpgsProviders : object [] = [];
  paymentMethodsBackup : object[] = [];
  paymentOp = '';
  merchantForm : FormGroup;
  creditForm : FormGroup;
  cashForm : FormGroup;
  public domainForms = [];
	loading = false;
  merchantForm$: Observable<boolean>;
	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  @Output() onFormSubmit: EventEmitter<object> = new EventEmitter();
  @Input() title:string="";
  PaymentOptionsName = PaymentOptions;
  payment_methods : object[] = [];
  paymentMethods;
  selectedPaymentOptions = []
  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private fb : FormBuilder,
    private ProviderList : ProviderListService,
    private paymentMethodsService : PaymentMethodsService,
    public formValidator: FormValidatorService,
    private translate:TranslateService
  ) {
		this.unsubscribe = new Subject();
   }


	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

  async ngOnInit() {
    await this.initForm();
    await this.getPaymentMethods()
    await this.getProviders();
  }

  async getPaymentMethods(){
    this.paymentMethodsService.setParams({});
    let res = await this.paymentMethodsService.make();
    this.paymentMethods  = res.paymentOptions.filter(ele=>ele.providersCount > 0);
    this.paymentMethodsBackup = this.paymentMethods;
    this.cdr.detectChanges;
  }

  async getProviders(){
    this.ProviderList.setParams({
      "date": "",
      "search": "",
      "pageSize": 1000,
      "pageNumber": 1,
      "sort": "createdAt",
      "sortType": "ASC",
      "columns":[ "name","flatRate","OnUSRate","OffUsRate","createdAt" ]
    });
    let responsData = await this.ProviderList.make();
    for(let provider of responsData.providers){

      if(provider['paymentOption']['display_name'] == PaymentOptions.CASH){
        this.cashProviders.push(provider);

      } else if (provider['paymentOption']['display_name'] == PaymentOptions.MIGS_CREEDIT_CARD) {
        this.migsProviders.push(provider)
      }  else if (provider['paymentOption']['display_name'] == PaymentOptions.MPGS_CREEDIT_CARD) {
        this.mpgsProviders.push(provider)
      }
    }
    this.cdr.detectChanges();
  }

  addCashProvider(data : {providerId? : any,merchantId? : any,flatRate? : any,OnUSRate? : any}){
    this.cashPrivders.push(
      this.fb.group({
      providerId : [data.providerId ||'' , Validators.required],
      merchantId : [data.merchantId || ''],
      flatRate : [data.flatRate || '' , Validators.required],
      OnUSRate : [data.OnUSRate ||''],
      // OffUsRate : ['']
    }));

  }

  removeCash(i:number) {
    this.cashPrivders.removeAt(i);
  }

  get cashPrivders(): FormArray {
    return this.cashForm.get('cashPrivders') as FormArray;
  }
  initForm() {
    this.initMerchantForm();
    this.cashForm = this.fb.group({
      cashPrivders : this.fb.array([])
    });

    this.addCashProvider({});
    this.creditForm = this.fb.group({
      providerId : ['' , val.required],
      merchantId : ['' , val.required],
      accessCode : ['' , val.required],
      flatRate : ['' , val.required],
      OnUSRate : ['' , val.required],
      OffUsRate : ['' , val.required]
      });

    this.domainForms.push(
      new FormGroup({
				domain: new FormControl(),
			})
    );
  }

  providerChange(event){

  }

  IsMigs(id : number){
    for(let ele of this.migsProviders){
      if(ele['id'] === id && ele['paymentOption']['name'] === PaymentOptions.MIGS_CREEDIT_CARD){
        return true;
      }
    }
    return false;
  }
  get creditCardProviders(){


   return this.selectedPaymentOptions.indexOf(PaymentOptions.MPGS_CREEDIT_CARD) > -1 ? this.mpgsProviders : this.migsProviders
  }

  sendFormData(){
    let domains = this.domainForms.map(domainForm => domainForm.value.domain);
    let providers = [];
    for(let option of this.selectedPaymentOptions){
      if(option === PaymentOptions.CASH){
        let allCashProviders = this.cashPrivders.value ;
        for(let cashProvider of allCashProviders){
          providers.push({
            providerId : cashProvider.providerId ,
            flatRate : cashProvider.flatRate ,
            OnUSRate : cashProvider.OnUSRate ,
            // OffUsRate : cashProvider.OffUsRate ,
            config : {
              merchantId : cashProvider.merchantId
            }
          });
        }
      } else {
        let creditConfig = {
          merchantId : this.creditForm.get('merchantId').value,
          accessCode : this.creditForm.get('accessCode').value
        };
        if(this.creditForm.get('secureHashSecret')){
          creditConfig['secureHashSecret'] = this.creditForm.get('secureHashSecret').value
        }
        providers.push({
          providerId : this.creditForm.get('providerId').value ,
          flatRate : this.creditForm.get('flatRate').value ,
          OnUSRate : this.creditForm.get('OnUSRate').value ,
          OffUsRate : this.creditForm.get('OffUsRate').value ,
          config : creditConfig
        });
      }
    }
    this.onFormSubmit.emit({
      ...this.merchantForm.value,
      providers,
      domains: domains
    });
  }
  paymentOptionChange(event){
    this.selectedPaymentOptions.push(event.value);
    if(event.value === PaymentOptions.MIGS_CREEDIT_CARD){
      this.creditForm.addControl('secureHashSecret',new FormControl('',[ val.required]));
    } else if(event.value === PaymentOptions.MPGS_CREEDIT_CARD){
      this.creditForm.removeControl('secureHashSecret');
    }
    this.paymentMethods =this.paymentMethods.filter(ele=>{;

      if(event.value.indexOf(PaymentOptions.Credit_Card) > -1){
        return ele.display_name.indexOf(PaymentOptions.Credit_Card) == -1
      }else{
        return ele.display_name != event.value
      }
    })
    this.cdr.detectChanges()
  }

  get formsValidation(){
    if( this.selectedPaymentOptions.length === 0) return true ;
    let formValid = !this.merchantForm.valid ;
    let cashValid = false;
    let creditValid = false;
    for(let option of this.selectedPaymentOptions){
      if(option === PaymentOptions.CASH){
        cashValid = !this.cashForm.valid;
      } else if(option === PaymentOptions.MIGS_CREEDIT_CARD || option === PaymentOptions.MPGS_CREEDIT_CARD) {
        creditValid = !this.creditForm.valid;
      }
    }
    return formValid || cashValid || creditValid;
  }
  deletePaymentOption(index : number ){
    this.selectedPaymentOptions.splice(index, 1);
    this.paymentMethods = this.paymentMethodsBackup;
    for(let option of this.selectedPaymentOptions){
      this.paymentMethods =this.paymentMethods.filter(ele=>{;

        if(option === PaymentOptions.Credit_Card){
          return ele.display_name.indexOf(PaymentOptions.Credit_Card) == -1
        }else{
          return ele.display_name != option
        }
      });
    }
  }

  addDomain(){
    this.domainForms.push(
      new FormGroup({
				domain: new FormControl(),
			})
    );
    this.cdr.detectChanges();
  }

  removeDomain(id){
    this.domainForms.splice(id,1);
    this.cdr.detectChanges();
  }
  initMerchantForm(){
    this.merchantForm=this.formValidator.createForm([
      {

        fieldName: "merchant_name",
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "merchant_name"
            })
          },
          {
            validatorFn: CustomValidators.customPattern(/(^[a-z ]+$)/i),
            message: this.translate.instant("FormValidation.TextOnly", {
              field: "merchant_name"
            })
          },
        ]
      },
      {

        fieldName: "fname",
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "fname"
            })
          },
          {
            validatorFn: CustomValidators.customPattern(/(^[a-z ]+$)/i),
            message: this.translate.instant("FormValidation.TextOnly", {
              field: "fname"
            })
          },
        ]
      },
      {

        fieldName: "lname",
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "lname"
            })
          },
          {
            validatorFn: CustomValidators.customPattern(/(^[a-z ]+$)/i),
            message: this.translate.instant("FormValidation.TextOnly", {
              field: "lname"
            })
          },
        ]
      },
      {

        fieldName: "email",
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "email"
            })
          },
          {
            validatorFn: Validators.email,
            message: this.translate.instant("FormValidation.ValidEmail", {
              field: "email"
            })
          },
        ]
      },
      {

        fieldName: "mobile",
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "mobile"
            })
          },
          {
            validatorFn: CustomValidators.customPattern(/(^[0-9\+]{3,}$)/),
            message: this.translate.instant("FormValidation.RequiredNumber", {
              field: "mobile"
            })
          },
        ]
      },
      {

        fieldName: "callBackUrl",
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "callBackUrl"
            })
          },
        ]
      },
    ])
  }
}
